// CheckboxGroup 注入的 key
export const CHECKBOX_GROUP_KEY = Symbol('CheckboxGroup');

